module.exports = __webpack_public_path__ + "img/ISO20000.c495adb0.png";